import { BroadcastChannel } from 'broadcast-channel';

export class Channels {
  public static likeChannel: BroadcastChannel;

  public static readingListChannel: BroadcastChannel;

  public static recentlyViewedChannel: BroadcastChannel;

  public static watchlistsChannel: BroadcastChannel;

  public static preferencesChannel: BroadcastChannel;

  public static savedSearchesChannel: BroadcastChannel;

  public static docketDocumentsChannel: BroadcastChannel;

  // Note: BroadcastChannel name should be unique across all MFEs. Otherwise postMessage will broadcast event to all MFEs and
  // this might cause unexpected behavior
  private static CHANNEL_PREFIX: string = 'CREDITSIGHTS-WEB';

  private static channelFullName = (name: string) => `${this.CHANNEL_PREFIX}_${name}`;

  public static initialize = (): void => {
    this.likeChannel = new BroadcastChannel(this.channelFullName('like'));
    this.readingListChannel = new BroadcastChannel(this.channelFullName('readingList'));
    this.recentlyViewedChannel = new BroadcastChannel(this.channelFullName('recentlyViewed'));
    this.watchlistsChannel = new BroadcastChannel(this.channelFullName('watchlists'));
    this.preferencesChannel = new BroadcastChannel(this.channelFullName('preferences'));
    this.savedSearchesChannel = new BroadcastChannel(this.channelFullName('savedSearches'));
    this.docketDocumentsChannel = new BroadcastChannel(this.channelFullName('docketDocuments'));
  };

  public static close = (): void => {
    this.likeChannel.close();
    this.readingListChannel.close();
    this.recentlyViewedChannel.close();
    this.watchlistsChannel.close();
    this.preferencesChannel.close();
    this.savedSearchesChannel.close();
    this.docketDocumentsChannel.close();
  };
}
